import React from 'react'

let ApplyContainer = props => (
    <div id="applicationcontainer" style={props.style}>
        <iframe title="Application Google Docs iframe" src="https://docs.google.com/forms/d/e/1FAIpQLSeHHizOze9nuQf9w0S9aCdCPO8HGmji39RH-dJePumRocy_Eg/viewform?embedded=true" id="applicationembed" className="tk-acumin-pro-wide" width="640" height="100%" frameBorder="0" marginHeight="0" marginWidth="0">LOADING...</iframe>
    </div>    
);

export default ApplyContainer;
